export default __webpack_public_path__ + "static/media/CAPABILITY_SHEETMETAL.31b46346.png";